module.exports = __webpack_public_path__ + "img/loeffler-logo-mobile.c6fc627d.svg";